/**
 * ZeroUnique Product Tabs
 * Transforms accordion structure into horizontal tabs
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initProductTabs();
  });

  function initProductTabs() {
    // Find the product info container
    const productInfo = document.querySelector('.product__info-container');
    if (!productInfo) return;

    // Find description and accordion elements
    const description = productInfo.querySelector('.product__description');
    const accordions = productInfo.querySelectorAll('.product__accordion');

    if (!description && accordions.length === 0) return;

    // Create tabs container
    const tabsContainer = document.createElement('div');
    tabsContainer.className = 'product-tabs-container';

    // Create tabs navigation
    const tabsNav = document.createElement('div');
    tabsNav.className = 'product-tabs';

    // Create tabs content wrapper
    const tabsContent = document.createElement('div');
    tabsContent.className = 'product-tabs-content';

    // Tab data array
    const tabsData = [];

    // Add Description tab if exists
    if (description && description.innerHTML.trim()) {
      tabsData.push({
        id: 'description',
        title: 'Description',
        content: description.innerHTML,
        element: description
      });
    }

    // Add accordion tabs
    accordions.forEach((accordion, index) => {
      const details = accordion.querySelector('details');
      if (!details) return;

      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');

      if (!summary || !content) return;

      const titleEl = summary.querySelector('.accordion__title');
      const title = titleEl ? titleEl.textContent.trim() : `Tab ${index + 1}`;

      // Generate slug from title
      const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

      tabsData.push({
        id: slug || `tab-${index}`,
        title: title,
        content: content.innerHTML,
        element: accordion
      });
    });

    if (tabsData.length === 0) return;

    // Build tabs HTML
    tabsData.forEach((tab, index) => {
      // Create tab button
      const tabBtn = document.createElement('button');
      tabBtn.className = 'product-tab' + (index === 0 ? ' active' : '');
      tabBtn.setAttribute('data-tab', tab.id);
      tabBtn.setAttribute('type', 'button');
      tabBtn.textContent = tab.title;
      tabsNav.appendChild(tabBtn);

      // Create tab content
      const tabContent = document.createElement('div');
      tabContent.className = 'tab-content' + (index === 0 ? ' active' : '');
      tabContent.id = 'tab-' + tab.id;
      tabContent.innerHTML = '<div class="tab-content__inner rte">' + tab.content + '</div>';
      tabsContent.appendChild(tabContent);
    });

    // Assemble tabs container
    tabsContainer.appendChild(tabsNav);
    tabsContainer.appendChild(tabsContent);

    // Find insertion point (after buy buttons or description)
    const buyButtons = productInfo.querySelector('.product-form');
    const shareBlock = productInfo.querySelector('[class*="share"]');

    // Insert tabs container
    if (description) {
      description.parentNode.insertBefore(tabsContainer, description);
    } else if (accordions.length > 0) {
      accordions[0].parentNode.insertBefore(tabsContainer, accordions[0]);
    }

    // Hide original elements
    if (description) {
      description.style.display = 'none';
    }
    accordions.forEach(accordion => {
      accordion.style.display = 'none';
    });

    // Add click handlers
    const tabButtons = tabsContainer.querySelectorAll('.product-tab');
    const tabContents = tabsContainer.querySelectorAll('.tab-content');

    tabButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab');

        // Remove active from all
        tabButtons.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));

        // Add active to clicked
        this.classList.add('active');
        const targetContent = tabsContainer.querySelector('#tab-' + tabId);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  }
})();
